import API from '@/lib/API.js'
import comun from './comun.js'
const lineas = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getSeccionales();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Lineas.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_linea == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_linea: 0,
                id_solic: 0,
                id_practica: 0,
                estado: 1
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_linea != 0) {
                data = await API.Lineas.modificar(state.Seleccionado);
                str += "Practica modificada"
            } else {
                data = await API.Lineas.alta(state.Seleccionado);
                str += `Nueva practica de alta`
            }
            let secs = await API.Lineas.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_linea)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_linea != 0) {
                data = await API.Lineas.modificar(entidad);
                str += "Practica modificada"
            } else {
                data = await API.Lineas.alta(entidad);
                str += `Nueva practica de alta'`
            }
            let secs = await API.Lineas.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_linea)
            commit("comun/mostrar", str)
            return 0;
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Lineas.eliminar(id);
                str += "Seccional eliminada"
            }
            let ents = await API.Lineas.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getSeccionales: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default lineas;